const BASE_URL =
  process.env.REACT_APP_OLE_APIS ||
  "https://microservices.dev.oleinsurance.com";
const REACT_APP_OLE_APIS =
  process.env.REACT_APP_OLE_APIS ||
  "https://microservices.dev.oleinsurance.com";
const REACT_APP_FLYWIRE_SCRIPT_URL =
  process.env.REACT_APP_FLYWIRE_SCRIPT_URL ||
  "https://checkout.flywire.com/flywire-payment.js";
const REACT_APP_FLYWIRE_ENV = process.env.REACT_APP_FLYWIRE_ENV || "demo";
const REACT_APP_FLYWIRE_CODE = process.env.REACT_APP_FLYWIRE_CODE || "OEI";
const REACT_APP_FLYWIRE_CODE_US =
  process.env.REACT_APP_FLYWIRE_CODE_US || "OER";
const REACT_APP_FLYWIRE_CODE_OTHER =
  process.env.REACT_APP_FLYWIRE_CODE_OTHER || "OER";
const REACT_APP_FLYWIRE_CALLBACK_URL =
  process.env.REACT_APP_FLYWIRE_CALLBACK_URL ||
  "https://microservices.dev.oleinsurance.com/api-payments/v1/webhooks/flywire/";
const REACT_APP_FLYWIRE_CALLBACK_VERSION =
  process.env.REACT_APP_FLYWIRE_CALLBACK_VERSION || "2";
const REACT_APP_FLYWIRE_RECURRENT_TYPE =
  process.env.REACT_APP_FLYWIRE_RECURRENT_TYPE || "tokenization";
const REACT_APP_OLE_API_KEY = process.env.REACT_APP_OLE_API_KEY || "admin";
const REACT_APP_AWS_RUM_IDENTITY_POOL_ID =
  process.env.REACT_APP_AWS_RUM_IDENTITY_POOL_ID;
const REACT_APP_AWS_RUM_ENDPOINT = process.env.REACT_APP_AWS_RUM_ENDPOINT;
const REACT_APP_AWS_RUM_APPLICATION_ID =
  process.env.REACT_APP_AWS_RUM_APPLICATION_ID;
const REACT_APP_AWS_RUM_REGION = process.env.REACT_APP_AWS_RUM_REGION;
const REACT_APP_TIME_REFRESH = process.env.REACT_APP_TIME_REFRESH || "300000";
const REACT_APP_CALENDAR_API_KEY =
  process.env.REACT_APP_CALENDAR_API_KEY || "admin";
const REACT_APP_CALENDAR_API_URL =
  process.env.REACT_APP_CALENDAR_API_URL ||
  "https://microservices.dev.oleinsurance.com/api-common/v1/calendar";
const REACT_APP_CALENDAR_EMAIL =
  process.env.REACT_APP_CALENDAR_EMAIL || "tech@olelife.com";
const REACT_APP_CALENDAR_SLOT_SIZE =
  process.env.REACT_APP_CALENDAR_SLOT_SIZE || "60";
const REACT_APP_CALENDAR_DAYS = process.env.REACT_APP_CALENDAR_DAYS || "10";
const REACT_APP_CALENDAR_GUEST_EMAIL =
  process.env.REACT_APP_CALENDAR_GUEST_EMAIL ||
  "alexander@olelife.com,noel@olelife.com,manuel@olelife.com";
const rawOmitPaymentThreshold =
  process.env.REACT_APP_RULE_OMIT_PAYMENT_AMOUNT_ANALYZED ||
  process.env.REACT_APP_RULE_OMIT_PAYMENT_AMOUNT_ANUALYZED;
const REACT_APP_RULE_OMIT_PAYMENT_AMOUNT_ANUALYZED = rawOmitPaymentThreshold
  ? parseFloat(rawOmitPaymentThreshold)
  : 2500;
const REACT_APP_RULE_OMIT_PAYMENT_COUNTRY_EXCEPTION =
  process.env.REACT_APP_RULE_OMIT_PAYMENT_COUNTRY_EXCEPTION || "EC";
const REACT_APP_COUNTRY_DEPLOY = process.env.REACT_APP_COUNTRY_DEPLOY || "INT";
const REACT_APP_SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://d777495477ff85f202b2526f3ea3a622@o4508812788695040.ingest.us.sentry.io/4510749440212992";
const REACT_APP_ENV = process.env.REACT_APP_ENV || "development";
const REACT_APP_QUOTATION_API_URL =
  process.env.REACT_APP_QUOTATION_API_URL ||
  "https://microservices.dev.olelife.com.br";
const REACT_APP_QUOTATION_API_KEY =
  process.env.REACT_APP_QUOTATION_API_KEY || "admin-br";
const REACT_APP_AUTHORIZENET_ACCEPT_URL =
  process.env.REACT_APP_AUTHORIZENET_ACCEPT_URL ||
  "https://test.authorize.net/payment/payment";
const REACT_APP_EMAIL_API_URL =
  process.env.REACT_APP_EMAIL_API_URL ||
  "https://services.dev.olelife.com/ole-api-email";
const REACT_APP_EMAIL_API_KEY = process.env.REACT_APP_EMAIL_API_KEY || "admin";
const REACT_APP_EMAIL_APPLICATION_ID =
  process.env.REACT_APP_EMAIL_APPLICATION_ID || "web-payment";
const REACT_APP_EMAIL_TEMPLATE_SCHEDULING =
  process.env.REACT_APP_EMAIL_TEMPLATE_SCHEDULING || "1105";

export {
  BASE_URL,
  REACT_APP_FLYWIRE_SCRIPT_URL,
  REACT_APP_FLYWIRE_ENV,
  REACT_APP_FLYWIRE_CODE,
  REACT_APP_FLYWIRE_CODE_US,
  REACT_APP_FLYWIRE_CODE_OTHER,
  REACT_APP_FLYWIRE_CALLBACK_URL,
  REACT_APP_FLYWIRE_CALLBACK_VERSION,
  REACT_APP_FLYWIRE_RECURRENT_TYPE,
  REACT_APP_OLE_API_KEY,
  REACT_APP_AWS_RUM_IDENTITY_POOL_ID,
  REACT_APP_AWS_RUM_ENDPOINT,
  REACT_APP_AWS_RUM_APPLICATION_ID,
  REACT_APP_AWS_RUM_REGION,
  REACT_APP_TIME_REFRESH,
  REACT_APP_CALENDAR_API_KEY,
  REACT_APP_CALENDAR_API_URL,
  REACT_APP_CALENDAR_EMAIL,
  REACT_APP_CALENDAR_SLOT_SIZE,
  REACT_APP_CALENDAR_DAYS,
  REACT_APP_OLE_APIS,
  REACT_APP_CALENDAR_GUEST_EMAIL,
  REACT_APP_RULE_OMIT_PAYMENT_AMOUNT_ANUALYZED,
  REACT_APP_RULE_OMIT_PAYMENT_COUNTRY_EXCEPTION,
  REACT_APP_COUNTRY_DEPLOY,
  REACT_APP_SENTRY_DSN,
  REACT_APP_ENV,
  REACT_APP_QUOTATION_API_URL,
  REACT_APP_QUOTATION_API_KEY,
  REACT_APP_AUTHORIZENET_ACCEPT_URL,
  REACT_APP_EMAIL_API_URL,
  REACT_APP_EMAIL_API_KEY,
  REACT_APP_EMAIL_APPLICATION_ID,
  REACT_APP_EMAIL_TEMPLATE_SCHEDULING,
};
